import React from "react";
import CoreContext from "./context";
import getDisplayName from "./getDisplayName";

export default function withContext(Component) {
    function WithContext(props) {
        return <CoreContext.Consumer>{(context) => <Component {...props} context={context} />}</CoreContext.Consumer>;
    }

    const name = getDisplayName(Component);

    WithContext.displayName = `WithContext(${name})`;

    return WithContext;
}
